export const SCREEN = {
  STATUS: {
    NEW: 1,
    IN_PROGRESS: 2,
    FINISHED: 3,
  },
  CATEGORY: {
    ALL: 'all'
  }
}